import React from 'react';
import { CFormCheck } from '@coreui/react-pro';
import TooltipWithIcon from '../Tooltips/TooltipWithIcon';

const SimpleCheckboxWithTooltip = ({ id, label, checked, onChange, tooltip }) => {
     return (
          <div className="d-flex align-items-center checkbox-with-tooltip">
               <CFormCheck id={id} label={label} checked={checked} onChange={onChange} />
               <div
                    className="btn-tooltip"
                    onClick={(e) => {
                         e.stopPropagation();
                    }}
               >
                    <TooltipWithIcon content={tooltip} trigger="mouseenter focus" />
               </div>
          </div>
     );
};

export default SimpleCheckboxWithTooltip;
